module.exports = __webpack_public_path__ + "img/ic-phone.da7045cd.svg";